export class EmployeeSalary {
    employeeSalaryId: number;
    employeeId: number;
    amount: number;
    startsFrom: Date;
}